import { UserGroupDto } from '../types'

export class UserGroup {
  id: number

  buildingId: number

  groupName: string

  authorId: number

  createdAt: string

  updatedAt: string

  userIds: number[]

  raw: any

  constructor(data: UserGroupDto | any) {
    this.raw = data || {}
    this.id = Number(data?.id || 0)
    this.buildingId = Number(data?.buildingId || data?.building_id || 0)
    this.groupName = data?.groupName || data?.group_name || data?.name || ''
    this.authorId = Number(data?.authorId || data?.author_id || 0)
    this.createdAt = data?.createdAt || data?.created_at || ''
    this.updatedAt = data?.updatedAt || data?.updated_at || ''

    const memberIds: number[] = []
    if (Array.isArray(data?.memberIds)) {
      data.memberIds.forEach((id: any) => {
        const uid = Number(id)
        if (uid && !memberIds.includes(uid)) memberIds.push(uid)
      })
    } else if (Array.isArray(data?.user_ids)) {
      data.user_ids.forEach((id: any) => {
        const uid = Number(id)
        if (uid && !memberIds.includes(uid)) memberIds.push(uid)
      })
    } else if (Array.isArray(data?.group_users)) {
      data.group_users.forEach((u: any) => {
        const uid = Number(u.user_id || u.id || u.userId)
        if (uid && !memberIds.includes(uid)) memberIds.push(uid)
      })
    } else if (Array.isArray(data?.members)) {
      data.members.forEach((u: any) => {
        const uid = Number(u.id || u.user_id || u.userId)
        if (uid && !memberIds.includes(uid)) memberIds.push(uid)
      })
    } else if (Array.isArray(data?.users)) {
      data.users.forEach((u: any) => {
        const uid = Number(u.id || u.user_id || u.userId)
        if (uid && !memberIds.includes(uid)) memberIds.push(uid)
      })
    }
    this.userIds = memberIds
  }

  static from(data: any): UserGroup {
    if (data instanceof UserGroup) return data
    return new UserGroup(data)
  }

  getMemberCount(): number {
    return this.userIds.length
  }

  hasMember(userId: number): boolean {
    return this.userIds.includes(userId)
  }

  addMember(userId: number): void {
    if (!this.hasMember(userId)) {
      this.userIds.push(userId)
    }
  }

  removeMember(userId: number): void {
    this.userIds = this.userIds.filter((id) => id !== userId)
  }
}

export default UserGroup
